import { EModelName } from './model-name';
import mongoose, { InferSchemaType } from 'mongoose';
import { Document } from 'mongoose';

export enum E_Token {
  SessionToken = 'session',
  RefreshToken = 'refresh',
}

const TokenSchema = new mongoose.Schema({
  token: { type: String, required: true },
  type: { type: String, required: true },
  user: {
    type: mongoose.Schema.Types.ObjectId,
    index: true,
    ref: EModelName.USER,
  },
  created: { type: Date, required: true },
});

export type T_TokenBase = InferSchemaType<typeof TokenSchema>;

// Extend the type to provide proper typing for token type
export interface T_Token extends Omit<T_TokenBase, 'type' | 'user'> {
  type: E_Token;
  user: string;
}

export type T_TokenDocument = T_Token &
  Document & {
    _id: string;
  };

export { TokenSchema };
